import React from "react";
import { Link } from "gatsby"
import Logo from "../../static/logo.png";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';


const LeftNavHeader = (props) => {
    const theme=useTheme();
    return <Box sx={{display: 'flex',
              alignItems: 'center',
              padding: theme.spacing(0, 1),
              ...theme.mixins.toolbar,// necessary for content to be below app bar
              justifyContent: 'center',}}>
                <img src={Logo} height={theme.mixins.toolbar.minHeight} alt="cbbratings.com" />
            </Box>;
}

const LeftNavFooter = (props) => {
    const theme=useTheme();
    const drawerWidth=props.drawerWidth;
    return  <Box position="fixed"
                sx={{top: 'auto', bottom: 0,
                    //derived from ...theme.mixins.toolbar, with addition of width property in @media queries:
                    minHeight:56,
                    "@media (min-width:0px)":{"minHeight":64, "width":`${drawerWidth}px`},
                    "@media (min-width:600px)":{ "minHeight":64, "width":`${drawerWidth}px`}
                    }}
            >
            <Divider/>
            <Box sx={{display:"flex",marginTop:"0px",marginBottom:"0px",...theme.mixins.toolbar,alignItems:"center",justifyContent:"center"}}>
                2026 cbbratings.com 
            </Box>
    </Box>;
}


const LeftNav=(props)=> {
    const drawerWidth=props.drawerWidth;
    
    return <>
            <Box component="div" >
                <LeftNavHeader />
                <Divider />
                <List>
                    <ListItem key="/"> <Link to="/">Home</Link></ListItem>
                    <ListItem><Link to="/thisseason">This Season's Ratings</Link></ListItem>
                    <ListItem><Link to="/today">Today's Matchups</Link></ListItem>
                    <ListItem><Link to="/historical">Historical Ratings</Link></ListItem>
                    <ListItem><Link to="/methodology">Methodology</Link></ListItem>
                    <ListItem><Link to="/performance">Predictability</Link></ListItem>
                </List>   
            </Box>
            <LeftNavFooter drawerWidth={drawerWidth}  />
        </>;
  };

export default LeftNav;